const config = {
  BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
  HOMEPAGE: process.env.NEXT_PUBLIC_SQUAD_HOMEPAGE,
  CHECKOUT: process.env.NEXT_PUBLIC_PUBLIC_CHECKOUT_URL
};

export default config;
